import { Component, OnInit, ChangeDetectorRef, AfterContentChecked, ChangeDetectionStrategy } from '@angular/core';
import { LoadService } from 'src/app/core/services/load.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingComponent implements OnInit, AfterContentChecked {

  constructor(public load: LoadService, private cd: ChangeDetectorRef) { }

  ngOnInit() {    
  }

  ngAfterContentChecked() {
    this.cd.detectChanges();
  }

  close(){
    this.load.close('#load-modal');
  }
  close2(){
    this.load.close('#load-modal2');
  }

}
